<template>
<div class="null-data">
  <img src="../../assets/images/null_data.png" alt="">
  <span>{{text}}</span>
</div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>

<style scoped  lang="scss">
.null-data {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-size: 20px;
  color: #666666;
  img {
    width: 242px;
    height: 187px;
  }
}
</style>
